export default __webpack_public_path__ + "static/media/creator_distribution.065b2d07.png";